import { render, staticRenderFns } from "./TabTreeView.vue?vue&type=template&id=05c84137&"
import script from "./TabTreeView.vue?vue&type=script&lang=js&"
export * from "./TabTreeView.vue?vue&type=script&lang=js&"
import style0 from "./TabTreeView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports